import http from 'plugins/axios'

export default {
  list(data) {
    return http.get({
      url: '/ta/admin/tenant/welfare/coupon/list',
      data,
    })
  },
  detail(data) {
    return http.get({
      url: '/ta/admin/tenant/welfare/coupon/detail',
      data,
    })
  },
  add(data) {
    return http.post({
      url: '/ta/admin/tenant/welfare/coupon/add',
      data,
    })
  },
  update(data) {
    return http.put({
      url: '/ta/admin/tenant/welfare/coupon/upd',
      data,
    })
  },
  options(data) {
    return http.get({
      url: '/ta/admin/tenant/welfare/coupon/options',
      data,
    })
  },
  positionOptions() {
    return http.get({
      url: '/ta/admin/tenant/welfare/coupon/position/options',
    })
  },
  vipEnums() {
    return http.get({
      url: '/ta/admin/tenant/vip/approval/enums',
    })
  },
  enabledCoins() {
    return http.get({
      url: '/ta/admin/tenant/coin/enabled',
      data: { type: 'SPOT' },
    })
  },
}
